export const flowTypes = {
  INSTAGRAM: "instagram",
  FLIPSHOP: "flipshop",
  TIKTOK: "tiktok",
};

// List of flow step types - add new flow step types here
export const FLOW_STEP_TYPES = [
  {
    name: "order",
    title: "Order",
  },
  {
    name: "flipshop",
    title: "Flipshop",
  },
  {
    name: "tiktok",
    title: "TikTok",
  },
  {
    name: "instagram",
    title: "Instagram",
  },
  {
    name: "review",
    title: "Review",
  },
];

export function getSubmitLink({ campaignFlowType, onboardId }) {
  const type = campaignFlowType || flowTypes.INSTAGRAM;

  return `${process.env.REACT_APP_INFLUENCER_BRAND_HOST}influencer/submit/${onboardId}/${type}`;
}
